import { render, staticRenderFns } from "./report-orders.vue?vue&type=template&id=7b8a8a08"
import script from "./report-orders.vue?vue&type=script&lang=js"
export * from "./report-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports